//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import ExpandItem from "../../global/transitions/ExpandItem.vue";

export default {
  name: "SearchQuery",
	components: {
		ExpandItem,
	},
	props: {
		results: Object,
		executeSearch: Function,
		setQuery: Function,
		query: String,
	},
	data() {
		return {
			inputInvalid: false,
			showSuggestions: false,
			allowSuggestionsOpen: true,
			showNoResultsMessage: true,
			userIsTyping: false,
			typingTimer: null,
		}
	},
	computed: {
		...mapGetters([
			"activeSearchTerm",
			"suggestions",
		]),
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				if (val.trim() != "") {
					this.inputInvalid = false;
				}
				this.setQuery(val);
				this.setStateValue(["activeSearchTerm", val]);
			},
		},
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		...mapActions([
			"getSuggestions"
		]),
		// If we need to disallow empty searches, 
		// add required attr to text input above to add below functionality
		handleEmptySubmit(e) {
			e.preventDefault();
			this.inputInvalid = true;
		},
		// add method that sets up typingTimer to clear userIsTyping after 500ms and returns a Promise for it
		setTimerPromise() {
			return new Promise((resolve, reject) => {
				this.typingTimer = setTimeout(() => {
					this.userIsTyping = false;
					resolve();
				}, 500);
			});
		},
		async handleTextInput(value, isFromUserInput) {
			this.userIsTyping = true;
			if (this.typingTimer) {
				clearTimeout(this.typingTimer);
				this.typingTimer = null;
			}	
			await this.setTimerPromise();
			if (value.trim().length >= 3) {
				if(this.options.endpoint.indexOf('professionals') > -1){
					//disable no results text on professionals search
					this.showNoResultsMessage = false;
				}
				await this.getSuggestions(this.options.autocompleteEndpoint);
				if (isFromUserInput) this.showSuggestions = true;
			} else this.showSuggestions = false;
		},
		returnSuggestionElements() {
			return [...this.$el.querySelectorAll('.search-query__suggestion:not(.search-query__suggestion--no-results)')];
		},
		generateKey(s) {
			if(s && s.textWithHightlights){
				let str = s.textWithHightlights;
				str = str.replace(/<[^>]*>?/gm, '');
				str = str.replace(/\s/g, "_");
				return str;
			} else{
				return '';
			}			
		},
		highlightNextSuggestion(e) {
			e.preventDefault();
			const inputIsFocused = this.$el.querySelector('.search-query__input').matches(':focus');
			let highlightedElementIndex;
			let suggestionElements = this.returnSuggestionElements();

			if (inputIsFocused) {
				suggestionElements[0]?.focus();
			} else {
				highlightedElementIndex = suggestionElements.findIndex(el =>
					el.matches(':focus')
				);
				if (highlightedElementIndex < suggestionElements.length - 1) {
					suggestionElements[highlightedElementIndex + 1]?.focus();
				} else {
					suggestionElements[0]?.focus();
				}
			}
		},
		highlightPreviousSuggestion(e) {
			e.preventDefault();
			const inputIsFocused = this.$el.querySelector('.search-query__input').matches(':focus');
			let highlightedElementIndex;
			let suggestionElements = this.returnSuggestionElements();

			if (inputIsFocused) {
				suggestionElements.at(-1)?.focus();
			} else {
				highlightedElementIndex = suggestionElements.findIndex(el =>
					el.matches(':focus')
				);
				if (highlightedElementIndex > 0) {
					suggestionElements[highlightedElementIndex - 1]?.focus();
				} else {
					suggestionElements.at(-1)?.focus();
				}
			}
		},
		leaveSuggestions() {
			this.allowSuggestionsOpen = false;
			this.showSuggestions = false;
			this.setStateValue(["suggestions", []]);
		},
		async searchForSuggestionTerm(term) {
			this.queryModel = term;
			this.leaveSuggestions(false);
			await this.executeSearch();
			this.setStateValue(["suggestions", []]);
			this.leaveSuggestions();
		},
	},
	watch: {
		async activeSearchTerm(newVal, oldVal) {
			if (newVal == "") {
				this.queryModel = "";
				await this.executeSearch();
				let urlSearchParams = new URLSearchParams(window.location.search);
				urlSearchParams.delete("query");
				if (!!urlSearchParams) {
					window.history.pushState({}, '', window.location.origin + window.location.pathname);
				} else {
					window.history.pushState({}, '', window.location.origin + window.location.pathname + "?" + urlSearchParams.toString());
				}
			}
		},
	},
	mounted() {
		this.queryModel = this.queryModel;
		document.body.addEventListener("click", e => {
			if (!this.$el.contains(e.target)) {
				this.leaveSuggestions();
			}
		});
	},
	created() {},
};
